 const terms = [
  {
    id : "acceptance",
    title: "Acceptance of Terms",
    text: "By accessing or using ESGBites, you acknowledge that you have read, understood, and agree to be bound by these terms and conditions, as well as our Privacy Policy. Your use of the Website constitutes your acceptance of these terms in full. If you do not agree with any of these terms, please do not use the Website.",
    subpoint: [],
  },
  {
    id : "usecontent",
    title: "Use of Content",
    text: "",
    subpoint: [
      {
        stitle: "Content Disclaimer",
        stext:
          "The content provided on ESGBites is for informational purposes only. It is not intended as professional advice and should not be relied upon as such. While we strive to provide accurate and up-to-date information, we do not endorse or guarantee the accuracy, completeness, or reliability of any information presented on the Website. The content on ESGBites should not be seen as a substitute for seeking professional advice in specific situations.",
      },
      {
        stitle: "Copyright",
        stext:
          "All content published on ESGBites, including articles, images, graphics, videos, and multimedia materials, is protected by copyright laws. All rights are reserved unless otherwise stated. You may not reproduce, distribute, modify, or republish any content from the Website without obtaining prior written consent from ESGBites or the respective copyright holders. If you wish to use any content for non-commercial purposes, you must provide proper attribution to ESGBites.",
      },
    ],
  },
  {
    id : "contribution",
    title: "User Contributions",
    text: "",
    subpoint: [
      {
        stitle: "User Generated Content",
        stext: "ESGBites values user engagement and encourages thoughtful discussions. Users may contribute comments, articles, or other content to ESGBites, subject to certain guidelines. By submitting content, you grant ESGBites a non-exclusive, royalty-free, perpetual, and worldwide license to use, modify, reproduce, and distribute the content in any form. This allows us to share valuable insights and perspectives with the ESGBites community.",
      },
      {
        stitle: "Responsibility",
        stext: "You are solely responsible for the content you contribute to ESGBites. Content must not infringe upon the rights of any third party, violate any applicable laws, or promote any form of discrimination, harassment, or harm. ESGBites reserves the right to remove or modify user-generated content at its discretion, especially if it violates our community standards or terms of use.",
      },
    ],
  },
  {
    id : "termthird",
    title: "Third-party Links",
    text: "ESGBites may include links to third-party websites, events, or resources for informational purposes. These links do not imply endorsement or responsibility for the content, products, or services offered by third parties. Users access third-party websites at their own risk. We recommend that you review the terms and privacy policies of any third-party websites you visit through links on ESGBites.",
    subpoint: []
  },
  {
    id : "disclaimer",
    title: "Disclaimer of Warranties",
    text: 'ESGBites provides the Website on an "as is" and "as available" basis. While we strive to maintain the functionality and availability of the Website, we do not provide any warranty or guarantee regarding the availability, accuracy, timeliness, or performance of the Website. Your use of the Website is at your own risk. We disclaim all warranties, whether express or implied, including but not limited to the implied warranties of merchantability, fitness for a particular purpose, and non-infringement.',
    subpoint: []
  },
  {
    id : "limitations",
    title: "Limitation of Liability",
    text: 'To the fullest extent permitted by applicable law, ESGBites and its affiliates, directors, officers, employees, and agents shall not be liable for any direct, indirect, incidental, consequential, or punitive damages arising from your use of the Website or any content therein. This includes, but is not limited to, damages for loss of profits, data, goodwill, or other intangible losses. This limitation of liability applies even if ESGBites has been advised of the possibility of such damages.',
    subpoint: []
  },
  {
    id : "changeterms",
    title: "Changes to Terms",
    text: "ESGBites reserves the right to modify these terms and conditions at any time without prior notice. It is your responsibility to review these terms periodically to stay informed of any updates. Continued use of the Website after changes have been made implies your acceptance of the modified terms. If you do not agree to the modified terms, you should discontinue using the Website.",
    subpoint: []
  },
  {
    id : "governing",
    title: "Governing Law",
    text: "These terms and conditions are governed by and construed in accordance with the laws of California. Any disputes arising out of or related to these terms shall be subject to the exclusive jurisdiction of the courts of California. Any claims arising from the use of the Website must be brought within 2 months after the cause of action arises or be forever barred.",
    subpoint: []
  }
];

export default terms